import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import * as Cookies from 'js-cookie';
import { isPlatformBrowser } from '@angular/common';
import { TokenService } from '../services/auth/token.service';

@Injectable({
  providedIn: 'root'
})
export class IsVerifiedGuard implements CanActivate {
  browser = false;
  session = false;
  constructor(
    @Inject(PLATFORM_ID) platformId: string,
    protected tokenService: TokenService
  ) {
    this.browser = isPlatformBrowser(platformId);
    this.session = this.tokenService.isLoggedIn();
  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    /*if (this.browser) {
      let verified = Cookies.get('verified') == 'true';
      if (!verified) {
        if (this.session) {
          window.location.href = '/auth/verificacion?message=Antes de continuar debes verificar tu cuenta&redirectTo=' + window.location.pathname;
        }
        return false;
      }
      return true;
    }*/
    return true;
  }
}